import React from 'react'
import PropTypes from 'prop-types';
import _ from 'lodash'

import ArrayUtils from 'PMT/utils/ArrayUtils'

import ConditionRule from './ConditionRule'

const ConditionRulesList = ({ restaurantMenu, conditionRules, onChange, onDisplayItemSelector }) => (
  <div>
    {conditionRules.map((conditionRule, index) => (
      <ConditionRule
        // key={conditionRule.id}
        key={index}
        restaurantMenu={restaurantMenu}
        conditionRule={conditionRule}
        onChange={(rule) => onChange(ArrayUtils.updateObject(conditionRules, rule, (oldRule) => oldRule.id === rule.id))}
        onDelete={(rule) => onChange(ArrayUtils.removeObject(conditionRules, (oldRule) => oldRule.id === rule.id))}
        onDisplayItemSelector={onDisplayItemSelector}
      />
    ))}
  </div>
)

ConditionRulesList.propTypes = {
  restaurantMenu: PropTypes.object.isRequired,
  conditionRules: PropTypes.array,
  onChange: PropTypes.func.isRequired,
}

export default ConditionRulesList
